export const NS = 'NS';
export const EW = 'EW';
export const NWSE = 'NWSE';
export const NESW = 'NESW';

export default [NS, EW, NWSE, NESW];